var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighFiveIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "52px",
    viewBox: "0 0 65 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#FFD110",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 31.5,
    y1: 0.5,
    x2: 31.5,
    y2: 9.5,
    id: "Line-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 2.5,
    x2: 38.5,
    y2: 10.5,
    id: "Line-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.5,
    y1: 7.5,
    x2: 45.5,
    y2: 14.5,
    id: "Line-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 16.5,
    x2: 50.5,
    y2: 20.5,
    id: "Line-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 26.5,
    x2: 53.5,
    y2: 28.5,
    id: "Line-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 37.5,
    x2: 52.5,
    y2: 35.5,
    id: "Line-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 37.5,
    x2: 8.5,
    y2: 35.5,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 26.5,
    x2: 8.5,
    y2: 27.5,
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 16.5,
    x2: 11.5,
    y2: 20.5,
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 8.5,
    x2: 16.5,
    y2: 14.5,
    id: "Line-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 2.5,
    x2: 23.5,
    y2: 10.5,
    id: "Line-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.3583765,17.6158355 L39.2979732,27.3673481 L36.7214972,20.6545299 C36.4246154,19.8811266 36.8109125,19.0134891 37.5843159,18.7166073 C38.3577192,18.4197256 39.2253567,18.8060227 39.5222385,19.5794261 L45.0605433,34.006574 C46.5381016,32.5091867 48.4764326,31.9750248 49.9824219,36.3824463 C50.2913767,37.286632 50.8502376,38.6540166 51.1702881,39.7929287 C54.2440186,50.7309169 38.0445518,55.5051459 31.5263633,45.0851019 L31.6569732,45.2873481 L25.8582901,40.0666224 C25.2426488,39.5122965 25.1929428,38.5638506 25.7472688,37.9482093 C26.3015947,37.3325679 27.2500406,37.282862 27.8656819,37.8371879 L31.3432645,40.9687376 C32.5314383,41.384326 33.0627485,40.888628 32.9371954,39.4816438 L26.5768249,23.7396553 C26.2664907,22.9715511 26.6375866,22.0973039 27.4056908,21.7869696 C28.1737951,21.4766354 29.0480422,21.8477313 29.3583765,22.6158355 L33.4542376,32.7551395 C33.7366618,32.844858 34.0318536,32.9186645 34.3095137,32.9299558 L28.5768249,18.7396553 C28.2664907,17.9715511 28.6375866,17.0973039 29.4056908,16.7869696 C30.1737951,16.4766354 31.0480422,16.8477313 31.3583765,17.6158355 L37.10754,31.8444716 C37.4603499,31.9245854 37.788695,32.0650938 38.0203546,32.2104794 L32.5768249,18.7396553 C32.2664907,17.9715511 32.6375866,17.0973039 33.4056908,16.7869696 C34.1737951,16.4766354 35.0480422,16.8477313 35.3583765,17.6158355 Z M42.2145086,36.7818939 L42.155186,36.8456755 C42.488449,37.401997 42.7576025,37.6638192 42.8782879,37.3532715 C42.9077636,37.2774247 42.9531832,37.1725828 43.0130776,37.0452907 L42.5803725,35.9175796 C42.5537874,36.2367914 42.4251515,36.5406362 42.2145086,36.7818939 Z",
    id: "Combined-Shape",
    stroke: "#FFD110",
    fill: "#FFFFFF",
    transform: "translate(38.458050, 33.778326) scale(-1, 1) translate(-38.458050, -33.778326) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3583765,17.6158355 L31.7085369,30.8597832 C32.4813725,30.802544 33.1458446,30.6500949 33.3200684,30.2017822 C33.330593,30.1747002 33.3423282,30.1479998 33.3552463,30.1217842 L29.7214972,20.6545299 C29.4246154,19.8811266 29.8109125,19.0134891 30.5843159,18.7166073 C31.3577192,18.4197256 32.2253567,18.8060227 32.5222385,19.5794261 L38.0064457,33.8647525 C38.3277867,34.5879217 38.6543825,35.4224076 38.9824219,36.3824463 C39.0167502,36.4829114 39.0541638,36.589095 39.0939922,36.7000483 L39.3312295,37.3174542 C39.353502,37.3754759 39.3719293,37.434028 39.3866367,37.4928297 C39.6585439,38.2299629 39.9640149,39.0588976 40.1702881,39.7929287 C43.2440186,50.7309169 27.0445518,55.5051459 20.5263633,45.0851019 L20.6569732,45.2873481 L14.8582901,40.0666224 C14.2426488,39.5122965 14.1929428,38.5638506 14.7472688,37.9482093 C15.3015947,37.3325679 16.2500406,37.282862 16.8656819,37.8371879 L20.1058945,40.7551585 C21.2296607,41.1280668 21.9055867,40.8651907 22.1336726,39.96653 L15.5768249,23.7396553 C15.2664907,22.9715511 15.6375866,22.0973039 16.4056908,21.7869696 C17.1737951,21.4766354 18.0480422,21.8477313 18.3583765,22.6158355 L22.9546699,33.9930517 C23.4825383,34.0826236 23.9747843,34.0875785 24.4663777,33.3172362 L18.5768249,18.7396553 C18.2664907,17.9715511 18.6375866,17.0973039 19.4056908,16.7869696 C20.1737951,16.4766354 21.0480422,16.8477313 21.3583765,17.6158355 L27.3635293,32.4816763 C27.8734587,32.8086541 28.9836658,32.433036 28.715332,31.4399414 L28.7229732,31.4783481 L23.5768249,18.7396553 C23.2664907,17.9715511 23.6375866,17.0973039 24.4056908,16.7869696 C25.1737951,16.4766354 26.0480422,16.8477313 26.3583765,17.6158355 Z",
    id: "Combined-Shape",
    fill: "#FFD110"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighFiveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/highFive_icon.1d0a4ac12bfd2321b5dda6e84a66776a.svg";